import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, Box } from '@chakra-ui/react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (event: React.ChangeEvent<any>) => {
    const newLang = event.target.value;
    i18n.changeLanguage(newLang); // Change language dynamically
  };

  return (
    <Box width="80px">
      <Select  bg="brand.teal" _hover={{ bg: "brand.hoverteal" }} fontWeight="bold" 
      sx={{
        '> option': {
          background: 'brand.hoverteal', // Styles the background of dropdown options
          color: 'black', // Styles the text color of dropdown options
          _focus: 'red'
        },
      }}
        value={i18n.language} // Set the current language as the value
        onChange={changeLanguage}
        aria-label="Select language">
        <option value="en">EN</option>
        <option value="fr">FR</option>
      </Select>
    </Box>
  );
};

export default LanguageSwitcher;